import { VbzInputText } from "@smiles/voebiz-ui-kit";
import React from "react";
import { useTranslation } from "react-i18next";
import { Control, Controller } from "react-hook-form";

import { formatCEP, handleKeyPressNumber } from "../../../utils/documentUtils";

const AddressForm = ({ control, errors }: { control: Control; errors: any }) => {
  const { t } = useTranslation("register_company");
  return (
    <div className="vbz-company-container-address-fields-right">
      <div className="inputTextContainer withError">
        <Controller
          name="zipCode"
          rules={{
            required: true,
            maxLength: 10,
            minLength: 10,
          }}
          control={control}
          render={({ name, onChange, value }) => (
            <VbzInputText
              placeholder={t("input.text.zipCode.placeholder")}
              name={name}
              maxLength={10}
              onKeyDown={handleKeyPressNumber}
              inputMode="numeric"
              textLabel={t("input.text.zipCode.label")}
              errorMessage={t("input.text.zipCode.error")}
              forceError={Boolean(errors.zipCode)}
              onChange={(e) => onChange(formatCEP(e.target.value))}
              value={value}
            />
          )}
        />
      </div>
      <div className="vbz-company-container-address-fields columns">
        <div className="inputTextContainer withError">
          <Controller
            name="state"
            control={control}
            render={({ name, onChange, value }) => (
              <VbzInputText
                name={name}
                placeholder={t("input.text.state_fu.placeholder")}
                textLabel={t("input.text.state_fu.label")}
                forceError={Boolean(errors.state)}
                onChange={onChange}
                value={value}
                disabled
              />
            )}
          />
        </div>

        <div className="inputTextContainer withError">
          <Controller
            name="city"
            control={control}
            render={({ name, onChange, value }) => (
              <VbzInputText
                name={name}
                placeholder={t("input.text.city.placeholder")}
                textLabel={t("input.text.city.label")}
                forceError={Boolean(errors.state)}
                onChange={onChange}
                value={value}
                disabled
              />
            )}
          />
        </div>
      </div>
      <div className="inputTextContainer withError">
        <Controller
          name="streetAddress"
          control={control}
          render={({ name, onChange, value }) => (
            <VbzInputText
              name={name}
              placeholder={t("input.text.address.placeholder")}
              textLabel={t("input.text.address.label")}
              onChange={onChange}
              value={value}
              disabled
            />
          )}
        />
      </div>

      <div className="vbz-company-container-address-fields columns">
        <div className="inputTextContainer withError">
          <Controller
            name="streetAddressNumber"
            control={control}
            render={({ name, onChange, value }) => (
              <VbzInputText
                name={name}
                placeholder={t("input.text.number.placeholder")}
                textLabel={t("input.text.number.label")}
                onChange={onChange}
                value={value}
              />
            )}
          />
        </div>

        <div className="inputTextContainer withError">
          <Controller
            name="complement"
            control={control}
            render={({ name, onChange, value }) => (
              <VbzInputText
                name={name}
                placeholder={t("input.text.extra_info.placeholder")}
                textLabel={t("input.text.extra_info.label")}
                onChange={onChange}
                value={value}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default AddressForm;
